import { render, staticRenderFns } from "./UserToolbar.vue?vue&type=template&id=f99de37c&scoped=true&"
var script = {}
import style0 from "./UserToolbar.vue?vue&type=style&index=0&id=f99de37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99de37c",
  null
  
)

export default component.exports